import type { BadgeColor, BadgeIcon } from "~/components/ui/Badge/Badge.svelte";

const STYLE_COLOR_MAP: Record<string, BadgeColor> = {
  sale: "red",
  subdued: "white",
  primary: "charcoal",
};

const ICON_MAP: Record<string, BadgeIcon> = {
  Tag: "tag",
  Box: "box",
  None: "none",
};

export function mapStyleToColor(style: string | undefined | null): BadgeColor {
  return STYLE_COLOR_MAP[style?.toLowerCase() ?? ""] ?? "charcoal";
}

export function mapIconToBadgeIcon(icon: "None" | "Tag" | "Box" | null | undefined): BadgeIcon {
  return (icon != null ? ICON_MAP[icon] : undefined) ?? "none";
}
